<script setup>
import {
    FORMS,
} from '../../../utils/form-settings';
import {
    log,
} from '../../../utils/action-logger';

import AppButton from '../../atoms/app/AppButton';
import AppCollapseBox from '../../molecules/app/AppCollapseBox';
import {
    minitaskEvents, useMinitaskEditForm,
} from '../../../composables/minitask-edit-form';

defineProps({
    gaPrefix: {
        type: String,
    },
});
const emit = defineEmits([...minitaskEvents, 'add']);

const {
    skipped,
} = useMinitaskEditForm({ key: 'minitask-language', emit });

function handleAddClick() {
    emit('updated');
    emit('add', FORMS.language);
    log('profile-minitask', {
        label: 'language',
        result: 'add',
    });
}
</script>

<template>
    <AppCollapseBox>
        <template #headline>
            Welche Sprachen beherrscht du?
        </template>
        <template #interaction>
            <AppButton
                data-qa="add button"
                :data-gtm-element="gaPrefix ? `${gaPrefix}: Minitask - Proceed` : undefined"
                :data-gtm-element-detail="gaPrefix ? 'Language' : undefined"
                @click="handleAddClick"
            >
                Sprachen hinzufügen
            </AppButton>
            <AppButton
                variant="outline"
                data-qa="skip button"
                :data-gtm-element="gaPrefix ? `${gaPrefix}: Minitask - Skip` : undefined"
                :data-gtm-element-detail="gaPrefix ? 'Language' : undefined"
                @click="skipped"
            >
                Später
            </AppButton>
        </template>
        <template #collapse-content>
            Welche Sprachen beherrscht du?
        </template>
    </AppCollapseBox>
</template>
